import { FunctionalComponent, h } from "@stencil/core";
import {
    CookieSettings,
    CookieSettingsItemLocalized,
} from "../../cookie-consent";

interface ControlsProps {
    baseClass: string;
    options: CookieSettingsItemLocalized[];
    settings: CookieSettings;
}

export const Controls: FunctionalComponent<ControlsProps> = ({
    baseClass,
    options,
    settings,
}) => {
    return (
        <div class={`${baseClass}__controls`}>
            {options.map(({ key, label, desc, required }) => (
                <ux-cookie-layer-switch
                    key={key}
                    name={key}
                    label={label}
                    desc={desc}
                    on={required || settings[key] === true}
                    disabled={required}
                />
            ))}
        </div>
    );
};
